import * as React from 'react';
import './ItemComponentTypePage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { IItemComponentTypeReduxFormState, initialItemComponentTypeState } from "../../../reducers/reactReduxForms/itemComponentType";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as ItemComponentTypeActions from '../../../actions/itemComponentType';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { Form, actions, Control } from 'react-redux-form';
import { LookupsLayout } from '../../index';

interface IItemComponentTypePageParams {
    itemComponentTypeId: number;
}

interface IItemComponentTypePageProps {

    form: Dtos.ItemComponentType & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IItemComponentTypeReduxFormState;

    location: Location;
    itemComponentTypeId: number;
    match: match<IItemComponentTypePageParams>;
    history: History;

    // From state
    itemComponentType: Dtos.ItemComponentType;
    lookups: Dtos.Lookup[];

    loadingItemComponentType: boolean;
    loadItemComponentTypeSuccess: boolean;
    loadItemComponentTypeFailure: boolean;

    savingItemComponentType: boolean;
    saveItemComponentTypeSuccess: boolean;
    saveItemComponentTypeFailure: boolean;

    creatingItemComponentType: boolean;
    createItemComponentTypeSuccess: boolean;
    createItemComponentTypeFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface IItemComponentTypePageActions {
    clearItemComponentType: ItemComponentTypeActions.IItemComponentTypeClearActionCreator;
    loadItemComponentType: ItemComponentTypeActions.IItemComponentTypeLoadByIdActionCreator;

    saveItemComponentType: ItemComponentTypeActions.IItemComponentTypeSaveActionCreator;
    createItemComponentType: ItemComponentTypeActions.IItemComponentTypeCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type ItemComponentTypePageProps = IItemComponentTypePageProps & IItemComponentTypePageActions;


const formName: string = "notetype";
const reduxFormName: string = "reduxForms.itemComponentType";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}


class ItemComponentTypePage extends React.PureComponent<ItemComponentTypePageProps, any> {

    constructor(props: ItemComponentTypePageProps) {
        super(props);

        this.clearItemComponentType = this.clearItemComponentType.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadItemComponentType,
            navigate,
            navigateReplace,
            itemComponentTypeId,
            createItemComponentType
        } = this.props;

        if (itemComponentTypeId) {
            loadItemComponentType(itemComponentTypeId);
        } else if (!itemComponentTypeId) {
            createItemComponentType();
        }
    }

    componentWillReceiveProps(nextProps: ItemComponentTypePageProps) {
    }

    componentDidUpdate(prevProps: ItemComponentTypePageProps, prevState) {
        const {
            navigateReplace,
            itemComponentTypeId,
            itemComponentType,
            form,
            navigate,
            loadItemComponentType,
            loadingItemComponentType,
            loadItemComponentTypeSuccess,
            createItemComponentType,
            creatingItemComponentType,
            createItemComponentTypeSuccess,
            savingItemComponentType,
            saveItemComponentTypeSuccess,
            saveItemComponentTypeFailure,
            validationFailures
        } = this.props;

        if (itemComponentTypeId && prevProps.itemComponentTypeId != itemComponentTypeId) {
            loadItemComponentType(itemComponentTypeId);
        }
        else if (!itemComponentTypeId && prevProps.itemComponentTypeId) {
            createItemComponentType();
        }

        if (!loadingItemComponentType && prevProps.loadingItemComponentType) {
            if (loadItemComponentTypeSuccess) {
                this.loadForm();
            }
            else {

            }
        }


        if (!savingItemComponentType && prevProps.savingItemComponentType) {
            if (saveItemComponentTypeSuccess) {
                if (validationFailures && validationFailures.length > 0) {

                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {

                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);

                }
                if (form.saveAndReturn) {
                    navigate("/settings/general/itemComponenttypes")
                } else if (!form.saveAndReturn && itemComponentTypeId && itemComponentTypeId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !itemComponentTypeId && itemComponentType && itemComponentType.id > 0) {
                    navigate("/settings/general/itemComponenttypes/" + itemComponentType.id);
                }
            }
            else {

                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );

            }
        }

        if (!creatingItemComponentType && prevProps.creatingItemComponentType) {
            if (createItemComponentTypeSuccess) {
                this.loadForm();
            }
            else {

            }
        }

    }

    componentWillUpdate(nextProps: ItemComponentTypePageProps) {
    }

    componentWillUnmount() {

        const {
            resetForm,
            loadForm
        } = this.props

        this.clearItemComponentType();
        loadForm(reduxFormName, initialItemComponentTypeState);
        resetForm(reduxFormName);
    }

    clearItemComponentType() {
        this.props.clearItemComponentType();
    }

    showItemComponentType(): boolean {
        const {
            loadingItemComponentType,
            loadItemComponentTypeSuccess
        } = this.props

        if (!loadingItemComponentType && loadItemComponentTypeSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingItemComponentType
        } = this.props;

        return <LookupsLayout loading={loadingItemComponentType} permission={Dtos.Permission.ItemComponentTypesView}>
            {this.renderContent()}
        </LookupsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingItemComponentType,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.ItemComponentTypesUpdate, Dtos.Permission.ItemComponentTypesCreate);
        const formDisabled: boolean = !hasPermission || savingItemComponentType || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };



        return <div>
            <h1>Item Component Type</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "itemcomponenttype", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.ItemComponentType) {
        const {
            saveItemComponentType
        } = this.props;

        if (data) {
            let changes: Dtos.Institution = {} as Dtos.Institution;
            saveItemComponentType(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.ItemComponentType) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/general/itemComponenttypes");
    }

    loadForm() {
        const {
            loadForm,
            itemComponentType,
        } = this.props

        let extraData: Dtos.ItemComponentType = {} as Dtos.ItemComponentType;

        loadForm(reduxFormName, Object.assign({ ...itemComponentType }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: ItemComponentTypePageProps): IItemComponentTypePageProps => {

    let itemComponentType: Dtos.ItemComponentType | undefined = !(state.itemComponentTypes.formData instanceof Array) ? state.itemComponentTypes.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
    return {

        match: ownProps.match,
        itemComponentTypeId: ownProps.match && ownProps.match.params.itemComponentTypeId && ownProps.match.params.itemComponentTypeId.toString() != "create" ? ownProps.match.params.itemComponentTypeId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        itemComponentType: itemComponentType!,

        loadingItemComponentType: state.itemComponentTypes.loadState && state.itemComponentTypes.loadState.status == RequestState.Pending,
        loadItemComponentTypeSuccess: state.itemComponentTypes.loadState && state.itemComponentTypes.loadState.status == RequestState.Success,
        loadItemComponentTypeFailure: state.itemComponentTypes.loadState && state.itemComponentTypes.loadState.status == RequestState.Failure,

        savingItemComponentType: state.itemComponentTypes.saveState && state.itemComponentTypes.saveState.status == RequestState.Pending,
        saveItemComponentTypeSuccess: state.itemComponentTypes.saveState && state.itemComponentTypes.saveState.status == RequestState.Success,
        saveItemComponentTypeFailure: state.itemComponentTypes.saveState && state.itemComponentTypes.saveState.status == RequestState.Failure,

        creatingItemComponentType: state.itemComponentTypes.createState && state.itemComponentTypes.createState.status == RequestState.Pending,
        createItemComponentTypeSuccess: state.itemComponentTypes.createState && state.itemComponentTypes.createState.status == RequestState.Success,
        createItemComponentTypeFailure: state.itemComponentTypes.createState && state.itemComponentTypes.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: [],

        form: state.reduxForms.itemComponentType,
        formState: state.itemComponentTypes.formState,
        formProperties: state.itemComponentTypes.formProperties,

        reduxFormState: state.reduxForms.formState.itemComponentType,
        validationFailures: itemComponentType ?
            state.itemComponentTypes.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): IItemComponentTypePageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadItemComponentType: bindActionCreators(ItemComponentTypeActions.LoadItemComponentTypeById, dispatch),
        clearItemComponentType: bindActionCreators(ItemComponentTypeActions.Clear, dispatch),

        saveItemComponentType: bindActionCreators(ItemComponentTypeActions.SaveItemComponentType, dispatch),
        createItemComponentType: bindActionCreators(ItemComponentTypeActions.CreateItemComponentType, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(ItemComponentTypePage);
